import { render, staticRenderFns } from "./schedule-covid19.vue?vue&type=template&id=448098aa&scoped=true&"
import script from "./schedule-covid19.vue?vue&type=script&lang=js&"
export * from "./schedule-covid19.vue?vue&type=script&lang=js&"
import style0 from "./schedule-covid19.vue?vue&type=style&index=0&id=448098aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448098aa",
  null
  
)

export default component.exports